import React, { useEffect } from 'react';
import {Chart,   Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  PieController} from "chart.js";
import FlightsPriceTrends from "../components/FlightsPriceTrends";
import {flightsData} from "../assets/CompetitorsReportsData";
import {elAlData} from "../assets/ElAlData";
import AvgFlightPrice from "../components/AvgFlightPrice";
import PricePerDest from "../components/PricePerDest";
import PriceAnalysis from "../components/PriceAnalysis";
import DestPriceByAirline from "../components/DestPriceByAirline";

ChartJS.register(
    PieController,
    ArcElement,
    Tooltip,
    Legend
);

const Cockpit: React.FC = () => {

useEffect(() => {
  setTimeout(() => {
  }, 1000);
    priceAdj()
}, [])

  const data = [
    {
      "company name": "El Al Israel",
      "date": "11/27/2024",
      "price": 442,
      "destination": "Singapore",
      "priceReduction": true
    },
    {
      "company name": "El Al Israel",
      "date": "11/27/2024",
      "price": 442,
      "destination": "Singapore",
      "priceReduction": true
    },
    {
      "company name": "El Al Israel",
      "date": "11/27/2024",
      "price": 442,
      "destination": "Singapore",
      "priceReduction": true
    },
    {
      "company name": "El Al Israel",
      "date": "12/17/2024",
      "price": 630,
      "destination": "Sydney",
      "reanalysis": true
    },
    {
      "company name": "El Al Israel",
      "date": "01/23/2024",
      "price": 254,
      "destination": "Hong Kong",
      "reanalysis": true
    },

    {
      "company name": "El Al Israel",
      "date": "11/29/2024",
      "price": 361,
      "destination": "Bangkok",
      "priceRaise": true
    },
    {
      "company name": "El Al Israel",
      "date": "09/14/2024",
      "price": 578,
      "destination": "Los Angeles",
      "priceReduction": true
    },
    {
      "company name": "El Al Israel",
      "date": "02/02/2024",
      "price": 980,
      "destination": "Singapore",
      "priceRaise": true
    },
    {
      "company name": "El Al Israel",
      "date": "05/20/2024",
      "price": 1046,
      "destination": "Tokyo",
      "priceRaise": true
    }];
  const concattedData = flightsData.concat(elAlData)

  function priceAdj(){
    interface PriceAdj {
      "company name": string,
      date: string,
      price: number,
      destination: string,
      reanalysis?: boolean,
      priceRaise?: boolean,
      priceReduction?: boolean
    }
    const data:PriceAdj[] = [
      {
        "company name": "El Al Israel",
        "date": "11/27/2024",
        "price": 442,
        "destination": "Singapore",
        "priceReduction": true
      },
      {
        "company name": "El Al Israel",
        "date": "11/27/2024",
        "price": 442,
        "destination": "Singapore",
        "priceReduction": true
      },
      {
        "company name": "El Al Israel",
        "date": "11/27/2024",
        "price": 442,
        "destination": "Singapore",
        "priceReduction": true
      },
      {
        "company name": "El Al Israel",
        "date": "12/17/2024",
        "price": 630,
        "destination": "Sydney",
        "reanalysis": true
      },
      {
        "company name": "El Al Israel",
        "date": "01/23/2024",
        "price": 254,
        "destination": "Hong Kong",
        "reanalysis": true
      },

      {
        "company name": "El Al Israel",
        "date": "11/29/2024",
        "price": 361,
        "destination": "Bangkok",
        "priceRaise": true
      },
      {
        "company name": "El Al Israel",
        "date": "09/14/2024",
        "price": 578,
        "destination": "Los Angeles",
        "priceReduction": true
      },
      {
        "company name": "El Al Israel",
        "date": "02/02/2024",
        "price": 980,
        "destination": "Singapore",
        "priceRaise": true
      },
      {
        "company name": "El Al Israel",
        "date": "05/20/2024",
        "price": 1046,
        "destination": "Tokyo",
        "priceRaise": true
      }];
    const counts = {
      priceRaise: 0,
      priceReduction: 0,
      reanalysis: 0
    };

    data.forEach(entry => {
      if (entry.priceRaise) counts.priceRaise++;
      else if (entry.priceReduction) counts.priceReduction++;
      else if (entry.reanalysis) counts.reanalysis++;
    });

    const labels = ['Price Raise', 'Price Reduction', 'Reanalysis'];
    const dataset = [counts.priceRaise, counts.priceReduction, counts.reanalysis];
    const backgroundColors = ['rgb(47 94 146)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)'];
    const borderColors = ['rgb(47 94 146)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)'];

    // @ts-ignore
    const ctx = document.getElementById('priceAdjustmentChart')?.getContext('2d');
    new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [{
          data: dataset,
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }]
      },
      options: {
        plugins: {
          title: {
            display: true,
            text: 'Price Adjustment Distribution',
            font: {
              size: 20
            },
            padding: {
              top: 20,
              bottom: 30
            }
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: 14
              },
              usePointStyle: true,
              padding: 20
            }
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const label = context.label || '';
                const value = context.raw || 0;
                const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                //@ts-ignore
                const percentage = ((value / total) * 100).toFixed(2);
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        }
      }
    })
    return true
  }

  return (
      <div>
        <div className="image-blocks-container" style={{marginBottom: '20px'}}>
          <div className="row" style={{display: 'flex', justifyContent: 'center', marginBottom: '10px'}}>
            <div style={{width: '49%'}}>
              <FlightsPriceTrends data={{ flightsData: concattedData }} />

            </div>
            <div style={{width: '49%'}}>
              <DestPriceByAirline data={{ flightsData: concattedData }} />
            </div>
          </div>
          <div className="row" style={{display: 'flex', justifyContent: 'center'}}>
            <div  style={{width: '32%'}}>
              <AvgFlightPrice data={{ flightsData: concattedData}}/>
            </div>
            <div  style={{width: '32%'}}>
              <PricePerDest flightsData={flightsData} elAlData={elAlData}/>
            </div>

            <div  style={{width: '32%'}}>
              <PriceAnalysis data={data}></PriceAnalysis>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Cockpit;
